// --- Our Modules --------------------------------------------------------------------------------
import Skeleton from "@/UI/atoms/Skeleton";
import "./styles.css";

// --- Logic --------------------------------------------------------------------------------------

export default function Loader() {
    return (
        <div className="one-log-screen">
            <Skeleton className="one-log-skeleton-head" />
            {Array.from({ length: 3 }, (_, index) => (
                <Skeleton key={index} className="one-log-skeleton-section" />
            ))}
        </div>
    );
}
